const Main = () => import('../../pages/main')
const Console = () => import('../../pages/siteAdmin/Console')
const Member = () => import('../../pages/siteAdmin/member-component/MemberCenter.vue')
const Site = () => import('../../pages/siteAdmin/site-component/WebSiteContainer.vue')
const Shanxiu = () => import('../../pages/siteAdmin/member-component/Shanxiu.vue')
export default {
	path: '/tool',
	component: Main,
	redirect: {
		name: 'tool_site'
	},
	meta: {
		requiresAuth: true,
		hidden: false,
		title: '我的站点',
		icon: 'icon-nav icon-nav-tool',
		sideNav: true
	},
	children: [
		{
			name: 'console',
			path: 'console',
			component: Console,
			meta: {
				requiresAuth: true,
				hidden: true
			}
		},
		{
			name: 'tool_member',
			path: 'member',
			component: Member,
			meta: {
				requiresAuth: true,
				hidden: true
			}
		},
		{
			name: 'tool_site',
			path: 'site',
			component: Site,
			meta: {
				requiresAuth: true,
				hidden: true
			}
		},
		{
			name: 'shanxiu',
			path: 'shanxiu',
			component: Shanxiu,
			meta: {
				requiresAuth: true,
				hidden: true
			}
		},
	]
}
